import coverImg from "assets/images/v151/bg.webp"
import titleImg from "assets/images/v151/title.webp"

export const v151Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
}
